import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

export interface Announcement {
  id: string;
  text: string;
  active: boolean;
}

export interface AnnouncementPayload {
  text?: string;
  active?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {
  private readonly url = ApiConstants.URL_ANNOUNCEMENTS;

  constructor(private http: HttpClient) { }

  async list(): Promise<Announcement[]> {
    const response = await firstValueFrom(this.http.get<any>(this.url));
    return response.data;
  }

  async listActive(): Promise<Announcement[]> {
    const response = await firstValueFrom(this.http.get<any>(`${this.url}/active`));
    return response.data;
  }

  async create(body: AnnouncementPayload): Promise<Announcement> {
    const response = await firstValueFrom(this.http.post<any>(this.url, body));
    return response.data;
  }

  async update(id: string, body: AnnouncementPayload): Promise<Announcement> {
    const response = await firstValueFrom(this.http.patch<any>(`${this.url}/${id}`, body));
    return response.data;
  }

  async delete(id: string): Promise<Announcement> {
    const response = await firstValueFrom(this.http.delete<any>(`${this.url}/${id}`));
    return response.data;
  }
}
